import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
    {
      id: 'ssl',
      icon: 'Shield',
      title: 'SSL Secured',
      description: '256-bit encryption'
    },
    {
      id: 'gdpr',
      icon: 'Lock',
      title: 'GDPR Compliant',
      description: 'Data protection'
    },
    {
      id: 'verified',
      icon: 'CheckCircle',
      title: 'Verified Platform',
      description: 'Trusted by 50K+ traders'
    }
  ];

  const securityFeatures = [
    'Two-factor authentication',
    'Advanced fraud detection',
    'Secure data encryption',
    'Regular security audits'
  ];

  return (
    <div className="w-full max-w-md mx-auto mt-8">
      {/* Trust Badges */}
      <div className="grid grid-cols-3 gap-4 mb-6">
        {trustBadges?.map((badge) => (
          <div
            key={badge?.id}
            className="text-center p-3 bg-muted/50 rounded-md border border-border"
          >
            <div className="flex justify-center mb-2">
              <Icon name={badge?.icon} size={20} className="text-success" />
            </div>
            <h4 className="text-xs font-medium text-foreground mb-1">{badge?.title}</h4>
            <p className="text-xs text-muted-foreground">{badge?.description}</p>
          </div>
        ))}
      </div>
      {/* Security Features */}
      <div className="bg-card border border-border rounded-md p-4">
        <div className="flex items-center space-x-2 mb-3">
          <Icon name="Shield" size={16} className="text-primary" />
          <h3 className="text-sm font-medium text-card-foreground">Your Security Matters</h3>
        </div>
        <ul className="space-y-2">
          {securityFeatures?.map((feature, index) => (
            <li key={index} className="flex items-center space-x-2">
              <Icon name="Check" size={12} className="text-success" />
              <span className="text-xs text-muted-foreground">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* Compliance Info */}
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground">
          By signing in, you agree to our{' '}
          <button className="text-primary hover:text-primary/80 transition-standard">
            Terms of Service
          </button>{' '}
          and{' '}
          <button className="text-primary hover:text-primary/80 transition-standard">
            Privacy Policy
          </button>
        </p>
      </div>
    </div>
  );
};

export default TrustSignals;